<template>
  <AnalyticsCard
    title="Where you meet"
    subtitle="Location chosen on the booking"
    :loading="loading"
    :empty="!loading && rows.length === 0"
    empty-title="No bookings in this period"
    skeleton="list"
    :rows="4"
    :height="220"
  >
    <RankedRows :rows="rows" />
  </AnalyticsCard>
</template>

<script setup>
import { computed } from 'vue'
import AnalyticsCard from '../shared/AnalyticsCard.vue'
import RankedRows from '../shared/RankedRows.vue'
import { SERIES_COLORS } from '../shared/useAnalyticsChart.js'

const props = defineProps({
  data:    { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})

// `location_details->>'name'` is the raw key the booking form stored.
const LABELS = {
  google_meet: 'Google Meet',
  zoom: 'Zoom',
  phone_call: 'Phone call',
  in_person: 'In person',
  ask_invitee: 'Attendee chooses',
  no_location: 'No location set',
  unspecified: 'Not recorded',
}

const rows = computed(() => props.data.map((row, idx) => ({
  key: row.name,
  label: LABELS[row.name] || row.name,
  value: row.count,
  weight: row.count,
  swatch: SERIES_COLORS[idx % SERIES_COLORS.length],
  meta: row.share != null ? `${Math.round(row.share * 100)}%` : '',
})))
</script>
